import React from 'react';

export default function AddIcon({ altText, caption, canAdd, callback, id, isPostMerge }) {
  return (
    <div className="dropdown text-center">
      <span className="bg-white">{caption}</span>
      {canAdd ? (
        <span className="icon-plus" role="button" id={id} title={altText} onClick={e => callback(e, isPostMerge)} />
      ) : null}
    </div>
  );
}
